/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import Notification from 'apmui/components/Notification';
import ProgressAnimation from 'apmui/components/ProgressAnimation';
import RichText from 'apmui/components/markup/RichTextView';
import IPageModel from './Model';

/* View for EndpointSecurity */
export default class EndpointSecurityPageView extends React.Component<IPageModel> {
    render() {
        const state = this.props.eps.state;
        if (!state) {
            return <div className="apmui-content" />;
        }
        return (
            <div className="apmui-content">
                {state.status && <ProgressAnimation status={state.status} />}
                {state.text && (
                    <div>
                        <RichText text={state.text} />
                    </div>
                )}
                {state.notification && (
                    <Notification level="info">
                        <RichText text={state.notification} />
                    </Notification>
                )}
            </div>
        );
    }
}
